module.exports = __webpack_public_path__ + "img/right-carousel.eaa5800d.svg";